import React from 'react';
import { Dropdown, Field, Option } from '@fluentui/react-components';

interface IAnticipatedTerminationFYDropdownProps {
  value?: string;
  onChange: (value: string) => void;
}

const AnticipatedTerminationFYDropdown = (
  props: IAnticipatedTerminationFYDropdownProps,
): JSX.Element => {
  const { value, onChange } = props;

  const currentYear = new Date().getFullYear();
  const nextFiveYears = Array.from({ length: 5 }, (_, i) => currentYear + i);
  const fiscalYears = nextFiveYears.map((year: number) => ({
    key: `FY${(year % 100).toString().padStart(2, '0')}`,
    text: `FY${(year % 100).toString().padStart(2, '0')}`,
  }));

  return (
    <Field label="Anticipated Termination FY">
      <Dropdown
        placeholder="Select One"
        value={value || ''}
        selectedOptions={value ? [value] : []}
        onOptionSelect={(_ev, data) => onChange(data.optionValue ?? '')}
      >
        {fiscalYears.map((fy) => (
          <Option key={fy.key} value={fy.text}>
            {fy.text}
          </Option>
        ))}
      </Dropdown>
    </Field>
  );
};

export default AnticipatedTerminationFYDropdown;
